// src/Services/ordensDeServicoService.js
import { useBasicService } from "../../hooks/defaults/useBasicService"
import { endPointUser } from "../../models/constantes"

export function useUserService() {
	return useBasicService(
		endPointUser,
		({ controller, endpoint, userData }) => {
			const userController = controller(null, endpoint)

			return {
				async authOnSGP(loginForm) {
					return userController.post("auth", loginForm)
				},
				async updateFilterPref(form) {
					return userController.save("filterPref", form)
				},
				async loadTickets(userId) {
					return userController.get(`ticket/read/user/${userId}`)
				},
				async createTicket(form) {
					return userController.post("errorReport", form)
				},
				async loginFromToken(token) {
					return await userController.patch(
						"loginFromToken",
						null,
						{ Authorization: token }
					)
				},
				async authPlataform(user, pwd) {
					return await userController.post(
						"authPlataform",
						{ email: user, password: pwd }
					)
				},
			}
		}
	)
}
